module.exports = __webpack_public_path__ + "img/c3.3f47bfe1.png";